import { BrowserRouter, Routes, Route } from "react-router-dom"
import AuthRouter from './routers/AuthRouter'
import { AuthProvider } from './components/auth/useAuth'
import PrivateAdminRouter from './routers/AdminPrivateRouter'
import AdminRouter from './routers/AdminRouter'
import StudentPrivateRouter from './routers/StudentPrivateRouter'
import StudentRouter from './routers/StudentRouter'
import ParentPrivateRouter from './routers/ParentPrivateRouter'
import ParentRouter from './routers/ParentRouter'
import ChangePassword from './pages/auth/ChangePassword'

export default function App() {
	return (
		<>
			<BrowserRouter>
				<AuthProvider>
					<Routes>
						<Route path="/admin/*" element={ <PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
						<Route path="/student/change-password" element={ <StudentPrivateRouter><ChangePassword /></StudentPrivateRouter>} />
						<Route path="/student/*" element={ <StudentPrivateRouter><StudentRouter /></StudentPrivateRouter>} />
						<Route path="/parent/change-password" element={ <ParentPrivateRouter><ChangePassword /></ParentPrivateRouter>} />
						<Route path="/parent/*" element={ <ParentPrivateRouter><ParentRouter /></ParentPrivateRouter>} />
						<Route path="*" element={<AuthRouter />}/>
					</Routes>
				</AuthProvider>
			</BrowserRouter>
		</>
	)
}